import React from 'react';
import styled, { css } from 'styled-components';

import {
  Component,
  Header,
  StyledAlfaLeasingLogo,
  StyledButton,
  Title,
} from '@/components/modals/AlfaLeasingFormModal/AlfaLeasingFormModal.styles';
import CloseButton from '@/components/modals/shared/CloseButton';
import { media } from '@/utils/mixin';

import { AlfaLeasingIntroProps } from './types';

function AlfaLeasingIntro({ onClose, onNextStep }: AlfaLeasingIntroProps) {
  return (
    <Component>
      <CloseButton onClick={onClose} />

      <Header>
        <StyledAlfaLeasingLogo />
        <Title>
          Узнать, одобрит ли лизинговая компания вашу заявку - просто!
        </Title>
      </Header>

      <Content>
        <Text>
          Нужно ответить всего лишь на 5 вопросов анкеты и вы узнаете результат
        </Text>
      </Content>

      <Bottom>
        <ButtonWrapper>
          <StyledButton variant="contained" onClick={onNextStep}>
            Пройти тест
          </StyledButton>
        </ButtonWrapper>
      </Bottom>
    </Component>
  );
}

export default AlfaLeasingIntro;

const Content = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 69px;

  ${media.mobile(css`
    margin-top: 103px;
  `)}
`;

const Text = styled.p`
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  color: ${(props) => props.theme.black100};
`;

const Bottom = styled.div`
  margin-top: 77px;

  ${media.mobile(css`
    margin-top: 104px;
  `)}
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
